import styled from 'styled-components';

import { Color, Media } from '../../../../theme';
import { hexToRgba } from '../../../../utils';

export const Image = styled.img`
  min-width: 100%;
  height: 100%;
  filter: blur(0.05);
  transition: transform 0.7s;
  -webkit-backface-visibility: hidden; 
  -ms-transform: translateZ(0);
  -webkit-transform: translateZ(0); 
  transform: translateZ(0);
  ${Media.tablet`
    height: auto;
    max-width: 100%;
  `}
`;

export const Container = styled.a`
  height: 100%;
  width: 100%;
  position: relative;
  cursor: pointer;
  padding: 0;
  transition: all 0.7s;
  overflow: hidden;

  &:hover {
    ${Image} {
      transform: scale(1.2);
    }
  }
  & + & {
    margin-top: 5px;
  }
`;

export const ImageShadowContainer = styled.div`
  height: 100%;
  width: 100%;
  background: ${hexToRgba(Color.black, 0.15)};
  position: absolute;
  top: 0;
  left: 0;
`;

export const LabelShadowContainer = styled.div`
  height: 100%;
  width: 100%;
  background-image: linear-gradient(180deg, ${hexToRgba(Color.black, 0.01)} 56%, ${hexToRgba(Color.black, 0.25)} 96%);
`;

export const Label = styled.div`
  color: ${Color.white};
  font-size: 20px;
  letter-spacing: 0.2px;
  line-height: 25px;
  position: absolute;
  bottom: 30px;
  left: 30px;
`;
